import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { formatPrice } from "../utils/formatPrice";

import CartPage from '../components/common/headers/common/cart-header'
import { cart_actions } from '../redux-store'

const CartContainer = ({ cart, total_price, symbol, remove_from_cart, user }) => {
    // console.log(cart)
    return (
        <li className="onhover-div mobile-cart">
            <div className="cart-qty-cls">{cart.length}</div>
            <Link to={`${process.env.PUBLIC_URL}/cart`}>
                <img src={`${process.env.PUBLIC_URL}/assets/images/icon/cart.png`} className="img-fluid" alt="" />
                <i className="fa fa-shopping-cart"></i>
            </Link>
            <ul className="show-div shopping-cart">
                {cart.map((item, index) => (
                    <CartPage key={index} item={item} total={total_price} symbol={symbol} removeFromCart={() => remove_from_cart({ unit: item })} />
                ))}
                {(cart.length > 0) ?
                    <div>
                        <li>
                            <div className="total">
                                <h5>subtotal : <span>{formatPrice(total_price)}</span></h5>
                            </div>
                        </li>
                        <li>
                            <div className="buttons">
                                <Link to={`${process.env.PUBLIC_URL}/cart`} className="view-cart">view cart</Link>
                                <Link to={`${process.env.PUBLIC_URL}/${user ? "checkout" : "login"}`} className="checkout">checkout</Link>
                            </div>
                        </li>
                    </div>
                    :
                    <li>
                        <h5>Your cart is currently empty.</h5>
                    </li>
                }
            </ul>
        </li>
    )
}


function mapStateToProps(state) {
    return {
        cart: state.cart.items ? state.cart.items : [],
        total_price: state.cart.total_price,
        symbol: state.data.symbol,
        user: state.auth.user
    }
}

const mapDispatchToProps = (dispatch) => ({
    remove_from_cart: unit => dispatch(cart_actions.remove_from_cart(unit))
})

export default connect(mapStateToProps, mapDispatchToProps)(CartContainer);
